import React, { useState } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import { Box, Button } from 'theme-ui';

export const Dropdown = ({
  target,
  children,
  contentWidth,
  contentSx = {},
  sx,
  ...props
}: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const targetClass = 'open-target-button';

  return (
    <Box
      sx={{
        position: 'relative',
        ...sx,
      }}
    >
      <Button
        onClick={() => setIsOpen(!isOpen)}
        variant="minimal"
        className={targetClass}
        sx={{ width: '100%' }}
      >
        {target}
      </Button>
      {isOpen && (
        <OutsideClickHandler
          onOutsideClick={(e: any) => {
            if (!e.target?.parentElement.classList.contains(targetClass)) {
              setIsOpen(false);
            }
          }}
        >
          <Box
            sx={{
              zIndex: 'dropdown',
              position: 'absolute',
              top: '100%',
              right: 0,
              backgroundColor: 'surfaceGray',
              width: contentWidth || 220,
              boxShadow: '0px 16px 40px rgba(0, 0, 0, 0.16)',
              ...contentSx,
            }}
            onClick={() => setIsOpen(false)}
          >
            {children}
          </Box>
        </OutsideClickHandler>
      )}
    </Box>
  );
};
